import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_roadmap = () => {
  return instance.get(`/v1/mngr/roadmap`, { headers });
};

export const post_category_roadmap = (data) => {
  return instance.post(`/v1/mngr/roadmap-category`, data, { headers });
};

export const post_subcategory_roadmap = (data) => {
  return instance.post(`/v1/mngr/roadmap-subcategory`, data, { headers });
};

export const put_roadmap = (data) => {
  return instance.put(`/v1/mngr/roadmap`, data, { headers });
};

export const delete_roadmap = (id) => {
  return instance.delete(`/v1/mngr/roadmap/${id}`, { headers });
};
